__turbopack_context__.v({
  "advisorWidth": "profile-module-scss-module__8dazBa__advisorWidth",
  "avatar": "profile-module-scss-module__8dazBa__avatar",
  "avatarBlue": "profile-module-scss-module__8dazBa__avatarBlue",
  "avatarWhite": "profile-module-scss-module__8dazBa__avatarWhite",
  "profile": "profile-module-scss-module__8dazBa__profile",
  "profileMarginBottom": "profile-module-scss-module__8dazBa__profileMarginBottom",
  "profileName": "profile-module-scss-module__8dazBa__profileName",
  "profileTitle": "profile-module-scss-module__8dazBa__profileTitle",
  "profiles": "profile-module-scss-module__8dazBa__profiles",
  "threeLineEllipse": "profile-module-scss-module__8dazBa__threeLineEllipse",
});
